// Komponenta pro lazy loading fotografie stanice přes IntersectionObserver; načítá base64 z /api/img/geography
import { useState, useEffect, useRef } from 'react'

const BASE_URL = import.meta.env.VITE_API_URL || '/api'

export function StationPhoto({ ghId, size = 'm', className = '', alt = '' }) {
  const [src, setSrc] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const ref = useRef(null)
  const fetchedRef = useRef(false)

  useEffect(() => {
    if (!ghId) return
    fetchedRef.current = false
    setSrc(null)
    setError(false)

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !fetchedRef.current) {
          fetchedRef.current = true
          setLoading(true)
          fetch(`${BASE_URL}/img/geography?gh_id=${ghId}&size=${size}`)
            .then(r => r.json())
            .then(data => {
              if (data.photo) setSrc(`data:image/png;base64,${data.photo}`)
              else setError(true)
            })
            .catch(() => setError(true))
            .finally(() => setLoading(false))
        }
      },
      { threshold: 0.1 }
    )

    if (ref.current) observer.observe(ref.current)
    return () => observer.disconnect()
  }, [ghId, size])

  return (
    <div ref={ref} className={`bg-gray-100 flex items-center justify-center overflow-hidden ${className}`}>
      {loading && (
        <div className="w-full h-full animate-pulse bg-gray-200" />
      )}
      {src && !loading && (
        <img src={src} alt={alt || ghId} className="w-full h-full object-contain" />
      )}
      {error && !loading && (
        <span className="text-xs text-gray-400">—</span>
      )}
    </div>
  )
}